import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'supervecina-voting';
  footerItems = [
    {
      label: 'Inicio',
      url: 'http://supervecina.com/',
    },
    {
      label: '|',
      disabled: true,
    },
    {
      label: 'Política de privacidad',
      url: 'https://calculadora.supervecina.com/#/privacypolicy',
      target: '_blank',
    },
    {
      label: '|',
      disabled: true,
    },
    {
      label: 'Uso de cookies',
      url: 'https://calculadora.supervecina.com/#/cookiepolicy',
      target: '_blank',
    },
    {
      label: '|',
      disabled: true,
    },
    {
      label: 'Términos y condiciones',
      url: 'https://calculadora.supervecina.com/#/dataprotection',
      target: '_blank',
    },
  ];
}
